// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__XNGFR","text":"SelectPayment_text__3ZL9S","title":"SelectPayment_title__ixrfx","btn":"SelectPayment_btn__1kz74"};